import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from '@data/data.service';
import { NotificationService } from '@notification/notification.service';
import { OrderDataHandler } from '../order-data-handler';
import { MyLog } from '@common/common';
import { firstArray } from '@util/utils';

@Component({
  selector: 'app-close-order-dialog',
  templateUrl: './close-order-dialog.component.html',
})
export class CloseOrderDialogComponent implements OnInit {
  constructor(
    private dataService: DataService,
    public notificationService: NotificationService,
    public dialogRef: MatDialogRef<CloseOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {}

  ngOnInit(): void {}

  doCancel() {
    this.dialogRef.close(null);
  }

  doClose() {
    const dataHandler = OrderDataHandler.create(this.dataService);

    dataHandler.closeOrder(this.dialogData).subscribe((res: any) => {
      const result = res?.result || {};
      MyLog.log('CLOSE:RESULT:', result);

      if (result.success) {
        result.msg && this.notificationService.showSuccess(result.msg);
      } else {
        const errors = firstArray(result.errors, [
          'Status nicht geändert. Fehler auf dem Server',
        ]);
        this.notificationService.showErrors(errors);
      }
      this.dialogRef.close(true);
    });
  }
}
